import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TRANSLATIONS as t } from 'constants/translations';
import styles from './PaymentSuccessPage.module.css';

const PaymentSuccessPage = () => {
    const navigate = useNavigate();

    const [lang] = useState(() => localStorage.getItem('vending_lang') || 'Ko');

    const [cart] = useState(() => {
        try {
            const saved = localStorage.getItem('vending_cart');
            return saved ? JSON.parse(saved) : [];
        } catch {
            return [];
        }
    });

    const totalPrice = cart.reduce((acc, cur) => acc + cur.price * cur.count, 0);

    const serialNumber = localStorage.getItem('vending_serial');

    // 마운트 시 장바구니 초기화
    useEffect(() => {
        localStorage.removeItem('vending_cart');
    }, []);

    const handleOrderAgain = () => {
        if (serialNumber) {
            navigate(`/pay?SN=${serialNumber}`);
        } else {
            navigate('/pay');
        }
    };

    const getItemName = (item) =>
        item.productNames?.[lang] || item.productNames?.Ko || '';

    return (
        <div className={styles.container}>
            <div className={styles.successCard}>
                <div className={styles.iconWrapper}>
                    <svg className={styles.checkIcon} viewBox="0 0 52 52" fill="none">
                        <circle cx="26" cy="26" r="26" fill="#294068" />
                        <polyline
                            points="14,27 22,35 38,18"
                            stroke="#fff"
                            strokeWidth="3.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>

                <h2 className={styles.title}>{t.successTitle[lang]}</h2>
                <p className={styles.message}>{t.successMessage[lang]}</p>
            </div>

            {cart.length > 0 && (
                <div className={styles.orderCard}>
                    <h3 className={styles.sectionTitle}>{t.orderList[lang]}</h3>
                    <div className={styles.orderList}>
                        {cart.map((item) => (
                            <div key={item.id} className={styles.orderItem}>
                                <div className={styles.itemInfo}>
                                    <span className={styles.itemName}>{getItemName(item)}</span>
                                    <span className={styles.itemCount}>
                                        {t.quantity[lang]} {item.count}{t.unit[lang]}
                                    </span>
                                </div>
                                <span className={styles.itemPrice}>
                                    {(item.price * item.count).toLocaleString()}{t.currency[lang]}
                                </span>
                            </div>
                        ))}
                    </div>

                    <div className={styles.totalRow}>
                        <span className={styles.totalLabel}>{t.amountLabel[lang]}</span>
                        <span className={styles.totalValue}>
                            {totalPrice.toLocaleString()}{t.currency[lang]}
                        </span>
                    </div>
                </div>
            )}

            <div className={styles.footer}>
                <button className={styles.orderAgainBtn} onClick={handleOrderAgain}>
                    {t.orderAgain[lang]}
                </button>
            </div>
        </div>
    );
};

export default PaymentSuccessPage;
